import React from 'react';
import Banner from './Banner';
import Introduction from './Introduction';
import MyProfession from './MyProfession';
import MyUniversity from './MyUniversity';
import WebDevelopmentCourse from './WebDevelopmentCourse';
import MyProjects from './MyProjects';
import MyLocation from './MyLocation';
const Home = () => {
    return (
        <main data-aos="fade" data-aos-duration="1500" >
            <Banner></Banner>
            {/*
                some styles:
                1. className='border-t-[1px] border-[rgb(255,255,255,.15)] bg-gradient-to-r from-[rgb(2 ,22,43,.20)] via-[rgb(2 ,22,43,.20)] to-[rgba(0,0,0,0.40)] relative pt-6 pb-28 backdrop-blur-2xl'   
                2. className='border-t-[1px] border-[rgb(255,255,255,.15)] bg-gradient-to-r from-[rgb(255,255,255,.20)] via-[rgb(255,255,255,.20)] to-[rgba(0,0,0,0.40)] relative pt-6 pb-28 backdrop-blur-2xl'  
                3. className='border-t-[1px] border-[rgb(255,255,255,.15)] bg-[#00283a] relative pt-6 pb-28
              */}

            <div className='border-t-[1px] border-[rgb(255,255,255,.15)] bg-[#02162b] relative pb-28 overflow-hidden'>
                <Introduction />
                <MyProfession></MyProfession>
                <MyUniversity></MyUniversity>
                <WebDevelopmentCourse></WebDevelopmentCourse>
                <MyProjects></MyProjects>
                {/* <MyLocation></MyLocation> */}
            </div>
        </main >
    );
};

export default Home;